import { loginStore } from '../Components/Login/loginStore';
import { loggedInUser } from '../Store/user-store';

const U_COLLECTION = 'dn';
const CHANNEL_COLLECTION = 'test';
const PUBLISHED_COLLECTION = 'published';
const PREVIEW_COLLECTION = 'preview';
const MAPPING_COLLECTION = 'mapping';
const ALIAS_COLLECTION = 'alias';

export const login = async (email, password, firebaseApp) => {
  return firebaseApp.auth().signInWithEmailAndPassword(email, password);
};

export const loginAnonymously = async (firebaseApp) => {
  return firebaseApp.auth().signInAnonymously();
};

export const loginWithCustomToken = async (token, firebaseApp) => {
  return firebaseApp.auth().signInWithCustomToken(token);
};

export const logout = async (firebaseApp) => {
  return firebaseApp
    .auth()
    .signOut()
    .then(() => 'Success');
};

export const onAuthStateChanged = async (callback, firebaseApp) => {
  firebaseApp.auth().onAuthStateChanged(callback);
};

export const listenToChat = async (channelId, onSnapshotCallback, firebaseApp) => {
  return firebaseApp
    .firestore()
    .collection(CHANNEL_COLLECTION)
    .doc(channelId)
    .collection(PUBLISHED_COLLECTION)
    .orderBy('created', 'desc')
    .onSnapshot(onSnapshotCallback);
};

export const listenToChannel = async (channelId, onSnapshotCallback, firebaseApp) => {
  return firebaseApp
    .firestore()
    .collection(CHANNEL_COLLECTION)
    .doc(channelId)
    .onSnapshot(onSnapshotCallback);
};

export const addComment = async (channelId, commentData, firebaseApp) => {
  return firebaseApp
    .firestore()
    .collection(CHANNEL_COLLECTION)
    .doc(channelId)
    .collection(PREVIEW_COLLECTION)
    .add(commentData);
};

export const listenToChannelIds = async (onSnapshotCallback, firebaseApp) => {
  return firebaseApp.firestore().collection(MAPPING_COLLECTION).onSnapshot(onSnapshotCallback);
};

export const createUser = async (displayName, firebaseApp) => {
  return firebaseApp
    .firestore()
    .collection(U_COLLECTION)
    .add({ displayName: displayName, dn: displayName.toLowerCase() });
};

export const checkDisplayName = async (displayName, firebaseApp) => {
  const dn = displayName.toLowerCase();
  return firebaseApp.firestore().collection(U_COLLECTION).where('dn', '==', dn).get();
};

export const addAlias = async (userId, alias, firebaseApp) => {
  return firebaseApp.firestore().collection(ALIAS_COLLECTION).doc(userId.toString()).set({ alias });
};

export const checkAlias = async (alias, firebaseApp) => {
  return firebaseApp.firestore().collection(ALIAS_COLLECTION).where('alias', '==', alias).get();
};

export const playLogin = async (basePath, TV2User, firebaseApp) => {
  try {
    const response = await fetch(`${basePath}/play-login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: TV2User?.id,
        last_name: TV2User?.lastname,
        first_name: TV2User?.firstname,
        email: TV2User?.email,
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      loginStore.setErrorMessage(data.error);
    } else {
      const { user } = await loginWithCustomToken(data.firebaseToken, firebaseApp);

      loggedInUser.set(user);
    }
  } catch (err) {
    loginStore.setErrorMessage(err);
  }
};
